import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  User,
  Bell,
  Grid2x2,
  CircleHelp,
} from "lucide-react";
import { RiBankFill } from "react-icons/ri";

const Header = ({
  onOpenNotifications,
  hasNotifications = false,
}) => {

  const navigate = useNavigate();
  const location = useLocation();

  const menu = [
    {
      label: "Profile",
      icon: User,
      path: "/accounts/accounts-information",
    },
    {
      label: "Notifications",
      icon: Bell,
      action: "notification",
    },
    {
      label: "Apps",
      icon: Grid2x2,
      path: "#",
    },
    {
      label: "Help & Contact",
      icon: CircleHelp,
      path: "#",
    },
  ];

  

  return (
    <header className="h-[56px] bg-white border-b border-[#dddddd]">
      <div className="h-full px-[32px] flex items-center justify-between">

        {/* ================= LEFT ================= */}

        <div className="flex items-center">

          <RiBankFill
            size={18}
            className="text-[#d40511]"
          />

          <span className="ml-[8px] text-[14px] font-semibold text-[#111111]">
            UBS
          </span>

          <span className="ml-[10px] text-[14px] font-semibold text-[#5d6b7b]">
            E-Banking
          </span>

        </div>

        {/* ================= RIGHT ================= */}

        <div className="flex items-center gap-[26px]">

          {menu.map((item) => {
            const Icon = item.icon;

            const active =
              item.path &&
              location.pathname === item.path;

            return (
              <button
                key={item.label}
                onClick={() => {
                  if (item.action === "notification") {
                    onOpenNotifications();
                  } else {
                    navigate(item.path);
                  }
                }}
                className={`
                  relative
                  flex
                  items-center
                  gap-[3px]
                  text-[14px]
                  font-medium
                  transition-colors
                  duration-150
                  ${
                    active
                      ? "text-[#d40511]"
                      : "text-[#222222] hover:text-black"
                  }
                `}
              >
                {/* Notification Badge */}

                {item.action === "notification" &&
  hasNotifications && (
    <span
      className="
        absolute
        left-[7px]
        top-[-2px]
        w-[7px]
        h-[7px]
        rounded-full
        bg-[#d40511]
      "
    />
)}

                <Icon
                  size={15}
                  strokeWidth={1.8}
                />

                <span>{item.label}</span>
              </button>
            );
          })}

        </div>

      </div>
    </header>
  );
};

export default Header;